var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileFacebook = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 48,
  viewBox: "0 0 44 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 24,
  r: 22,
  fill: "#205CEF",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.7754 24.0354H24.0147V36.5717H18.4006V24.0354H15.7144V19.5925H18.4006V16.7041C18.4006 14.6481 19.4482 11.4288 24.0523 11.4288H28.1998V15.7363H25.1859C25.015 15.7268 24.8441 15.7533 24.6856 15.8136C24.5271 15.874 24.3852 15.9668 24.2702 16.0852C24.1553 16.2035 24.0702 16.3445 24.0213 16.4976C23.9725 16.6507 23.961 16.8121 23.9879 16.9699V19.5824H28.2858L27.7754 24.0354Z",
  fill: "#294DA5"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileFacebook);
export default ForwardRef;